<template>
    <v-row justify="center">
        <v-dialog
            class="user-modal"
            v-model="dialog"
            persistent
            max-width="450">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ headerText }}
                    </v-card-title>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="6">
                                        <v-text-field
                                            :label="$vuetify.lang.t('$vuetify.userFormModal.firstName')"
                                            v-model="form.first_name"
                                            placeholder=" "
                                            autocomplete="off"
                                            :rules="inputRules"
                                            :error-messages="errors.first_name">
                                        </v-text-field>
                                </v-col>
                                <v-col
                                    cols="6">
                                        <v-text-field
                                            :label="$vuetify.lang.t('$vuetify.userFormModal.lastName')"
                                            v-model="form.last_name"
                                            placeholder=" "
                                            autocomplete="off"
                                            :rules="inputRules"
                                            :error-messages="errors.last_name">
                                        </v-text-field>
                                </v-col>
                                <v-col
                                    cols="6">
                                        <v-text-field
                                            :label="$vuetify.lang.t('$vuetify.userFormModal.userName')"
                                            v-model="form.username"
                                            :disabled="!(mode === 'create')"
                                            placeholder=" "
                                            autocomplete="off"
                                            :rules="usernameRules"
                                            :error-messages="errors.username">
                                        </v-text-field>
                                </v-col>
                                <v-col
                                    cols="6">
                                        <v-text-field
                                            :disabled="!(mode === 'create')"
                                            :label="$vuetify.lang.t('$vuetify.userFormModal.password')"
                                            v-model="form.password"
                                            placeholder=" "
                                            autocomplete="off"
                                            :rules="passwordRules"
                                            type="password"
                                            :error-messages="errors.password">
                                        </v-text-field>
                                </v-col>
                                <v-col
                                    cols="12">
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.userFormModal.emailAddress')"
                                        v-model="form.email"
                                        placeholder=" "
                                        autocomplete="off"
                                        :rules="emailRules"
                                        :error-messages="errors.email">
                                    </v-text-field>
                                </v-col>
                                <v-col
                                    cols="12">
                                    <v-text-field
                                        v-model="phoneNumberMask"
                                        :label="$vuetify.lang.t('$vuetify.userFormModal.phoneNumber')"
                                        :prefix="`(${nationalTelCode})`"
                                        :rules="phoneRules"
                                        placeholder="00 000 0000"
                                        autocomplete="off"
                                        v-mask = "'## ### ####'"
                                        :error-messages="errors.phone_number">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-combobox
                                        v-model="selectedBranchs"
                                        item-text="name"
                                        :items="branchItems"
                                        :label="$vuetify.lang.t('$vuetify.userFormModal.branch')"
                                        placeholder=" "
                                        :rules="branchInputRules"
                                        multiple
                                        :error-messages="errors.branchIds">
                                    </v-combobox>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :label="$vuetify.lang.t('$vuetify.userFormModal.role')"
                                        v-model="form.roleId"
                                        item-text="name"
                                        item-value="id"
                                        :items="roleItems"
                                        :rules="inputRules"
                                        placeholder=" ">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitForm()">
                        {{ $vuetify.lang.t('$vuetify.userFormModal.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    name: 'UserFormModal',

    props: {
        mode: {
            type: String,
            default: ''
        },
        toUpdateUserId: {
            type: Number,
            default: null
        }
    },

    directives: {
        mask
    },

    computed: {
        headerText () {
            if (this.mode === 'create') {
                return this.$vuetify.lang.t('$vuetify.userFormModal.createNewMember')
            } else if (this.mode === 'update') {
                return this.$vuetify.lang.t('$vuetify.userFormModal.updateUserInfo')
            }
            return ''
        }
    },

    data () {
        return {
            dialog: false,
            valid: true,
            form: {
                first_name: '',
                last_name: '',
                username: '',
                password: '',
                email: '',
                branchIds: [],
                roleId: null,
                phone_number: ''
            },
            selectedBranchs: [],
            phoneNumberMask: '',
            inputRules: [
                v => this.$validator.hasValue(v, this.trans.userFormModal.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.userFormModal.thisFieldIsExceededCharacters)
            ],
            usernameRules: [
                v => this.$validator.hasValue(v, this.trans.userFormModal.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.userFormModal.thisFieldIsExceededCharacters),
                v => this.$validator.hasSomeCharacter(v, '#', this.trans.userFormModal.cannotHaveSharp)
            ],
            branchInputRules: [
                v => this.$validator.hasValue(v, this.trans.userFormModal.thisFieldIsRequired),
                v => this.$validator.arrayValueIn(v, this.branchItems, 'id', 'id', this.trans.userFormModal.thisFieldIsRequired)
            ],
            phoneRules: [
                v => this.$validator.lengthExactly(v, 11, this.trans.userFormModal.incorrectPhoneNubmer)
            ],
            nationalTelCode: '+66',
            emailRules: [
                vmail => this.$validator.hasValue(vmail, this.trans.userFormModal.emailIsRequired),
                vmail => this.$validator.lengthNotExceed(vmail, 255, this.trans.userFormModal.emailIsExceededCharacters),
                vmail => this.$validator.correctFormat(vmail, /.+@.+\..+/, this.trans.userFormModal.invalidEmailFormat)
            ],
            passwordRules: [
                v => this.$validator.hasValue(v, this.trans.userFormModal.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.userFormModal.thisFieldIsExceededCharacters),
                v => this.$validator.validatePassword(v, this.trans.userFormModal.cannotHaveSpace)
            ],
            errors: {},
            branchItems: [],
            roleItems: []
        }
    },

    methods: {
        openModal () {
            this.dialog = true
        },

        clearForm () {
            this.form = {
                first_name: '',
                last_name: '',
                username: '',
                password: '',
                email: '',
                branchIds: [],
                roleId: null,
                phone_number: ''
            }
            this.phoneNumberMask = ''
            this.selectedBranchs = []
        },

        closeModal () {
            this.clearForm()
            this.errors = {}
            this.$refs.form.resetValidation()
            this.$emit('modal-closed')
            this.dialog = false
        },

        cleanForm () {
            const keys = ['first_name', 'last_name', 'username', 'email']
            for (let i = 0; i < keys.length; i++) {
                this.form[keys[i]] = this.form[keys[i]].trim()
            }
        },

        async submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.cleanForm()

            if (this.mode === 'create') {
                await this.createUser()
            } else if (this.mode === 'update') {
                await this.updateUser()
            }
        },

        async getBranchs () {
            const res = await this.axios.get('branch/getAll')
            if (res && res.data && res.data.status === 'ok') {
                this.branchItems = res.data.data
            }
        },

        async getRoles () {
            const res = await this.axios.get('role/get')
            if (res && res.data && res.data.status === 'ok') {
                this.roleItems = res.data.data
            }
        },

        async createUser () {
            this.$store.dispatch('setLoading', true)
            this.form.phone_number = `${this.nationalTelCode} ${this.phoneNumberMask}`
            this.form.branchIds = this.selectedBranchs.map(branch => branch.id)

            const res = await this.axios.post('user/create', this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-created')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.userFormModal.congratulation,
                    text: this.trans.userFormModal.userIsCreated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.trans.userFormModal.errorMessage,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async updateUser () {
            this.$store.dispatch('setLoading', true)

            this.form.phone_number = `${this.nationalTelCode} ${this.phoneNumberMask}`
            this.form.branchIds = this.selectedBranchs.map(branch => branch.id)
            const form = {
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                email: this.form.email,
                branchIds: this.form.branchIds,
                roleId: this.form.roleId,
                phone_number: this.form.phone_number
            }
            const res = await this.axios.put(`user/edit/${this.toUpdateUserId}`, form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.userFormModal.congratulation,
                    text: this.trans.userFormModal.userIsUpdate,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.trans.userFormModal.errorMessage,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        mapBranchDataFromBranchId (branchIds) {
            const result = []
            for (let i = 0; i < branchIds.length; i++) {
                const foundBranch = this.branchItems.find(branch => branch.id === branchIds[i])
                result.push(foundBranch)
            }
            return result
        },

        async getUser (userId) {
            const res = await this.axios.get(`user/admin/${userId}`)

            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.data
                this.form.first_name = response.user.first_name
                this.form.last_name = response.user.last_name
                this.form.username = response.user.username
                this.form.email = response.user.email
                this.form.password = '********'
                // every user has one role at least
                this.form.roleId = response.roles[0]
                this.phoneNumberMask = response.phone_number.substr(4)
                this.form.phone_number = response.phone_number
                this.selectedBranchs = this.mapBranchDataFromBranchId(response.branchs)
            }
        }
    },

    async mounted () {
        await this.getBranchs()
        await this.getRoles()

        this.registerLang({
            userFormModal: [
                'createNewMember',
                'updateUserInfo',
                'thisFieldIsRequired',
                'thisFieldIsExceededCharacters',
                'incorrectPhoneNubmer',
                'emailIsRequired',
                'invalidEmailFormat',
                'emailIsExceededCharacters',
                'congratulation',
                'userIsCreated',
                'errorMessage',
                'congratulation',
                'userIsUpdate',
                'errorMessage',
                'cannotHaveSpace',
                'cannotHaveSharp'
            ]
        })
    },

    watch: {
        async mode (newValue, oldValue) {
            if (newValue === 'update') {
                await this.getBranchs()
                await this.getRoles()
                await this.getUser(this.toUpdateUserId)
            }
        },
        '$vuetify.lang.current': {
            handler: function (after, before) {
                if (this.dialog) {
                    this.$refs.form.resetValidation()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.user-modal-divider {
    .theme--light, .v-divider {
        border-color: rgb(148 148 148);
    }
}
.bold {
    font-weight: 500;
}
</style>
